import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-purple text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Transform Your Link Building?</h2>
        <p className="text-xl mb-10 max-w-3xl mx-auto opacity-90">
          Join thousands of SEO professionals on SEO Link Market and start connecting with quality partners today.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button size="lg" className="bg-white text-brand-blue hover:bg-gray-100 text-lg px-8">
            Create Account
          </Button>
          <Button size="lg" variant="outline" className="text-white border-white hover:bg-white/10 text-lg px-8">
            Learn More
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
